import { createSlice } from "@reduxjs/toolkit";
import { claimReminderTemplatesListAPI } from "../../services/claimReminderTemplates";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const claimReminderTemplateListSlice = createSlice({
  name: "getClaimReminderTemplates",
  initialState: data,
  reducers: {
    claimReminderTemplateInfo(state) {
      state.isLoading = true;
    },
    claimReminderTemplateSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    claimReminderTemplateFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    claimReminderTemplateReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const claimReminderTemplateListHandler = (data) => async (dispatch) => {
  try {
    dispatch(claimReminderTemplateAction.claimReminderTemplateInfo());
    const response = await claimReminderTemplatesListAPI(data);
    dispatch(claimReminderTemplateAction.claimReminderTemplateSuccess(response));
  } catch (e) {
    dispatch(claimReminderTemplateAction.claimReminderTemplateFailure(e));
  }
};
export default claimReminderTemplateListSlice.reducer;
export const claimReminderTemplateAction = claimReminderTemplateListSlice.actions;
